import { render, staticRenderFns } from "./EventDetailsComponent.vue?vue&type=template&id=d479f8f4&scoped=true"
import script from "./EventDetailsComponent.vue?vue&type=script&lang=js"
export * from "./EventDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./EventDetailsComponent.vue?vue&type=style&index=0&id=d479f8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d479f8f4",
  null
  
)

export default component.exports